import React from 'react'
import { FixedSizeList as List } from 'react-window'
import InfiniteLoader from 'react-window-infinite-loader' // More info: https://codesandbox.io/s/5wqo7z2np4?file=/src/App.js:67-120
import { components } from 'react-select'

const LOADING = 1
const LOADED = 2
const itemStatusMap = {}

const isItemLoaded = (index) => !!itemStatusMap[index]
const loadMoreItems = (startIndex, stopIndex) => {
  for (let index = startIndex; index <= stopIndex; index++) {
    itemStatusMap[index] = LOADING
  }
  return new Promise((resolve) =>
    setTimeout(() => {
      for (let index = startIndex; index <= stopIndex; index++) {
        itemStatusMap[index] = LOADED
      }
      resolve(null)
    }, 1000)
  )
}

// This is the modal that render the options for the select field. We needed to
// implement the InfiniteLoader component to render the options and make it work
// with many data and adapt it to the react-select component.
export const MenuList = (props) => {
  const childHeight = 35
  const maxHeight = childHeight * 5

  const calculateHeight = () => {
    if (props.children.length > 4) {
      return maxHeight
    } else {
      return props.children.length * childHeight
    }
  }
  if (props.children.length === undefined) {
    return props.children
  } else {
    return (
      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        itemCount={props.children.length}
        loadMoreItems={loadMoreItems}
      >
        {({ onItemsRendered, ref }) => (
          <List
            className="List"
            height={calculateHeight()}
            itemCount={props.children.length}
            itemSize={childHeight}
            onItemsRendered={onItemsRendered}
            ref={ref}
          >
            {({ index, style }) => (
              <div style={style}>{props.children[index]}</div>
            )}
          </List>
        )}
      </InfiniteLoader>
    )
  }
}

// To perform the select field for many data, we remove the
// onMouseMove and onMouseOver events from the legacy component
export const CustomOption = (props) => {
  delete props.innerProps.onMouseMove
  delete props.innerProps.onMouseOver
  const newProps = { ...props, innerProps: props.innerProps }
  return (
    <components.Option {...newProps} className="custom-option">
      {props.children}
    </components.Option>
  )
}
